import { Bot } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'

import { entityAiSettingsRoute } from './routes'

export const assistantModule = defineModule({
  routes: [entityAiSettingsRoute],
  navigation: {
    settings: [
      { to: '/$entityId/settings/ai', label: 'AI & MCP', icon: Bot, section: 'settings', order: 40 },
    ],
  },
})
